import { render, staticRenderFns } from "./TestApproval.vue?vue&type=template&id=d53a3f9c&scoped=true&"
import script from "./TestApproval.vue?vue&type=script&lang=js&"
export * from "./TestApproval.vue?vue&type=script&lang=js&"
import style0 from "./TestApproval.vue?vue&type=style&index=0&id=d53a3f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53a3f9c",
  null
  
)

export default component.exports